import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  calculations: [],
  // Set on first successful fetch — consumer pages fetch on demand once per session
  // (no longer preloaded at app startup; see App.js).
  loaded: false,
  error: null,
  isLoading: false
};

const locationsCalculationsSlice = createSlice({
  name: 'locationsCalculations',
  initialState,
  reducers: {
    // General loading state for any request
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // General failure state for any request
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // Fetch user transactions success
    fetchLocationsCalculationsSuccess: (state, action) => {
      state.calculations = action.payload;
      state.loaded = true;
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchLocationsCalculationsSuccess
} = locationsCalculationsSlice.actions;

export default locationsCalculationsSlice.reducer;
